import React, { useState } from "react";
import { Box, Paper, Tabs, Tab } from "@mui/material";

import AwsAccountsManager from "../components/credentials/AwsAccountsManager";

const Credentials = () => {
  const [tab, setTab] = useState(() => {
    const search = new URLSearchParams(window.location.search);
    const t = (search.get("tab") || "aws").toLowerCase();
    return "aws";
  });

  return (
    <Box className="credentials-page">
      <Paper className="credentials-card" elevation={3}>
        <Box className="credentials-tabs">
          <Tabs
            value={tab}
            onChange={(_, v) => {
              setTab(v);
              const url = new URL(window.location.href);
              url.searchParams.set("tab", v);
              window.history.replaceState({}, "", url);
            }}
          >
            <Tab label="AWS" value="aws" />
          </Tabs>
        </Box>

        <AwsAccountsManager />
      </Paper>
    </Box>
  );
};

export default Credentials;
